import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Download } from "lucide-react";
import { fetchFacturePublic } from "../../lib/facturation";
import { FACTURE_TRANSLATIONS, type FactureLangue } from "../../lib/facture-i18n";
import FactureApercu from "../../components/facturation/FactureApercu";

export default function FacturePublic() {
  const { token } = useParams<{ token: string }>();
  const [data, setData] = useState<Awaited<ReturnType<typeof fetchFacturePublic>>>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    fetchFacturePublic(token)
      .then(setData)
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, [token]);

  const handleDownloadPdf = () => {
    window.print();
  };

  if (loading) {
    return (
      <div style={{ fontFamily: "'Sora', sans-serif", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF6F1" }}>
        <div style={{ color: "#9A8878", fontSize: "1rem" }}>Chargement…</div>
      </div>
    );
  }

  if (!data || !data.facture) {
    return (
      <div style={{ fontFamily: "'Sora', sans-serif", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "#FAF6F1", padding: 24 }}>
        <div style={{ color: "#9A8878", fontSize: "1rem", marginBottom: 16 }}>Facture introuvable ou lien expiré.</div>
      </div>
    );
  }

  const { facture, client, lignes, dossier_infos } = data;
  const lang = (facture.langue || "fr") as FactureLangue;
  const t = FACTURE_TRANSLATIONS[lang] || FACTURE_TRANSLATIONS.fr;

  return (
    <div className="facture-public-page" style={{ fontFamily: "'Sora', sans-serif", minHeight: "100vh", background: "#FAF6F1", padding: "32px 24px" }}>
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
        <div className="no-print" style={{ marginBottom: 20, display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={handleDownloadPdf}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 20px",
              borderRadius: 10,
              border: "1px solid #EA7C3A",
              background: "#F97316",
              color: "white",
              fontWeight: 600,
              fontSize: "0.95rem",
              cursor: "pointer",
              fontFamily: "'Sora', sans-serif",
            }}
          >
            <Download size={20} strokeWidth={2} /> Télécharger en PDF
          </button>
        </div>
        <FactureApercu
          facture={facture}
          infos={dossier_infos}
          client={client}
          lignes={lignes}
          t={t}
        />
      </div>
      <style>{`
        @media print {
          body * { visibility: hidden; }
          .facture-public-page, .facture-public-page * { visibility: visible; }
          .facture-public-page { position: absolute; left: 0; top: 0; width: 100%; padding: 0; background: white; }
          .no-print { display: none !important; }
          .facture-apercu { box-shadow: none !important; border: 1px solid #ddd !important; }
        }
      `}</style>
    </div>
  );
}
